/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
// import { Link } from 'gatsby';
import ROUTES from '../../helpers/routes';
import { ICategory, ICategoryAncestor } from '../../helpers/interfaces';
import { excludeContentByCategorySlug } from '../../helpers/functions';

interface IBreadcrumbsProps {
  content: ICategory;
}

class Breadcrumbs extends React.Component<IBreadcrumbsProps> {
  render() {
    const { content } = this.props;
    // to reverse array of categories to make the order from  the farthest  to the closest
    let categories: ICategoryAncestor[] = [];
    if (content?.ancestors?.nodes) {
      categories =
        content.ancestors.nodes.length > 1
          ? content.ancestors.nodes.slice().reverse()
          : content.ancestors.nodes;
    }
    function shouldDisplay(): boolean {
      const toShow = !excludeContentByCategorySlug.includes(content.slug || '');
      if (!toShow) {
        return false;
      }
      return !categories.some((category) => {
        return excludeContentByCategorySlug.includes(category.slug);
      });
    }
    return (
      <>
        {shouldDisplay() ? (
          <nav aria-label="Breadcrumbs">
            {/* // REPLACE WITH GATSBY LINK */}
            <ul className="list-unstyled d-flex flex-wrap text-gray">
              <li className="mb-1 align-items-center d-flex">
                <a
                  href={ROUTES.HOME.toUrl()}
                  aria-label="Go to homepage"
                  className="text-decoration-underline-hover align-items-center d-inline-flex link-underline-gray">
                  <span className="ecs-font-icon-con-home text-gray font-icon-size-md" />
                </a>
                &nbsp;/&nbsp;
              </li>
              {categories?.length > 0
                ? categories.map((element) => (
                    <li
                      key={element.databaseId}
                      className="d-flex mb-1 align-items-center">
                      <a
                        href={ROUTES.CATEGORY.toUrl(element.uri)}
                        className="eyebrow-text text-gray text-decoration-underline-hover link-underline-gray">
                        {element.name}
                      </a>
                      &nbsp;/&nbsp;
                    </li>
                  ))
                : null}
              <li className="d-flex mb-1 align-items-center">
                <a
                  aria-current="page"
                  className="eyebrow-text link-underline"
                  href={ROUTES.CATEGORY.toUrl(content.uri)}>
                  {content.name}
                </a>
              </li>
            </ul>
          </nav>
        ) : null}
      </>
    );
  }
}
export default Breadcrumbs;
